export const message = {
  colorScheme: {
    dark: {
      info: {
        background: 'color-mix(in srgb, var(--p-primary-500), transparent 84%)',
        color: '{primary.100}',
      },
      warn: {
        background: 'color-mix(in srgb, var(--p-warn-500), transparent 84%)',
        color: '{warn.500}',
      },
    },
  },
}
